import { useEffect } from "react";
import { prettifyEnumLabel, usePrevious } from "../../../core";
import { EnumSelect, EnumSelectProps } from "../../inputs";
import { TableColumnDef } from "../types";

import styles from "./styles.module.scss";

export function EnumSelectColumn<T extends object = {}, TValue extends string | number | boolean = string, E = any>(
  { enumSelectProps, enumType, getLabel = prettifyEnumLabel as any, ...params }: TableColumnDef<T> & {
    enumType: E,
    getLabel?: (v: TValue | null) => string
    enumSelectProps?: EnumSelectProps<TValue, boolean, E>
  },
): TableColumnDef<T> {
  return {
    enableColumnFilter: true,
    minSize: 50,
    cell: props => {
      const value = props.getValue() as any;
      return <span className={styles.content}>{getLabel(value)}</span>;
    },
    ...params,
    meta: {
      defaultFilterFn: "equals",
      additionalFilterFn: [ "equals", "arrIncludesSome" ],
      Filter: ({ label, value, onChange, autoFocus, filterFn }) => {
        const previousFilterFn = usePrevious(filterFn);
        const isMulti = filterFn.toString()
          .includes("arrIncludes");

        useEffect(() => {
          if (!!previousFilterFn && previousFilterFn !== filterFn) {
            if (isMulti) {
              onChange([ value ]);
            } else {
              onChange(Array.isArray(value) ? value?.[0] : null);
            }
          }
        }, [ filterFn, onChange, previousFilterFn, value, isMulti ]);

        return (
          <EnumSelect<TValue, boolean, E>
            autoFocus={autoFocus}
            label={label}
            value={value as any}
            onChange={onChange}
            enumType={enumType}
            getOptionLabel={getLabel}
            isMulti={isMulti}
            {...enumSelectProps}
          />
        );
      },
      ...params?.meta,
      excelProps: {
        valueModifier: getLabel as any,
        filterButton: true,
        ...params?.meta?.excelProps,
      },
    },
  };
}
